const WIZARD_ASSET_BASE = "/assets/images/onboarding/wizard";
const LOADER_ASSET_BASE = `${WIZARD_ASSET_BASE}/loader`;

export const ONBOARDING_WIZARD_ASSETS = {
  edAvatarRing: `${WIZARD_ASSET_BASE}/ed-avatar-ring.svg`,
  edLogo: "/assets/images/ed-circle-logo-v2.svg",
  bubbleTailDark: `${WIZARD_ASSET_BASE}/bubble-tail-dark.svg`,
  bubbleTailLight: `${WIZARD_ASSET_BASE}/bubble-tail-light.svg`,
  nameBg: `${WIZARD_ASSET_BASE}/quiz-name-bg.webp`,
  valuePropWatermark: `${WIZARD_ASSET_BASE}/value-prop-watermark.svg`,
  planGoalBg: `/assets/plan-demo/goal-card-bg.webp`,
  homePlanGoalBg: `${WIZARD_ASSET_BASE}/plan-goal-bg.webp`,

  resultChart: `${WIZARD_ASSET_BASE}/result-chart-placeholder.webp`,
  edAvatar: `${WIZARD_ASSET_BASE}/intro-ed-avatar.webp`,
  scoreIntroBgMobile: `${WIZARD_ASSET_BASE}/score-intro-bg-mobile.webp`,
  scoreIntroBgDesktop: `${WIZARD_ASSET_BASE}/score-intro-bg-desktop.webp`,
  scoreIntroRadarDecor: `${WIZARD_ASSET_BASE}/radar-intro-decor.webp`,

  /** Figma Loader `96105:47690` / PC `96344:110625` — white Ed disc */
  loaderEdDisc: `${LOADER_ASSET_BASE}/ed-disc.svg`,
  /** Figma Loader `96105:47691` — teal ed mark inside disc */
  loaderEdMark: `${LOADER_ASSET_BASE}/ed-mark.svg`,
  /** Figma Loader `96105:47688` — contact shadow under avatar */
  loaderEdShadow: `${LOADER_ASSET_BASE}/ed-shadow.svg`,
} as const;
